// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"136":"74d86388","251":"bf690b54","425":"21ec3342","506":"3b8299aa","515":"a8134ac2","598":"eaa3d986","632":"7fd59b7b","738":"43f8b911","743":"5cfdf9f3","754":"9189459f","854":"1916cbef"}[chunkId] + ".chunk.js";
};